import { EntityDetailProps, EntityDetailTableProps } from "../../common/entity/EntityInterfaces";
import { NotAvailable, NotSet } from "../../common/misc/UIconstants";
import { Table } from "../../common/panels/Detail/DetailTable";
import { Link } from "react-router-dom";
import { DetailsPageTopControlsView } from "../../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import { LucideIcon } from "../../common/icon/LucideIcon";
import { useELNRoutes } from "../ELNRouter/useELNRoutes";
import { ViewOnlyContent } from "../LabNotebookEntries/LabNotebookEntryDetailContentTable";
import { toUppercase } from "../../common/helperfunctions/stringFunctions";
import { EntityDeleteButton } from "../../Entities/GenericComponents/common/GenericEntityDetailPage";
import { EntityEditButton } from "../../common/entity/entityComponents/EntityEditButton";
import { EntityCloneButton } from "../../common/entity/entityComponents/EntityCloneButton";
import { EntityComplianceDropdown } from "../../common/entity/entityComponents/EntityComplianceDropdown";

interface LabNotebookTemplatesDetailTableProps extends EntityDetailTableProps<"notebookTemplates"> {
  includeContent?: boolean;
}

export const LabNotebookTemplatesDetailTable = ({
  entity,
  entityConstants,
  fieldLabels,
  includeContent,
}: LabNotebookTemplatesDetailTableProps) => {
  return (
    <>
      <Table noPadding>
        <Table.Head>{toUppercase(entityConstants.entitySingular)} details</Table.Head>
        <Table.Body>
          <Table.Body.RowContent
            title={fieldLabels.name}
            content={
              <div className="container_label">
                <div className="container_label_name" style={{ fontWeight: 600 }}>
                  {entity.name ?? NotSet}
                </div>
                <div className="container_label_id">
                  <span style={{ whiteSpace: "nowrap" }}>
                    {toUppercase(entityConstants.entitySingular)}-ID: {entity.id ?? NotAvailable}
                  </span>
                </div>
              </div>
            }
          />

          <Table.Body.RowContent
            title={fieldLabels.description}
            content={
              <>
                {entity.description ? (
                  <div className="container_notes">
                    <textarea rows={4} className="container_textarea" value={entity?.description} disabled />
                  </div>
                ) : (
                  NotSet
                )}
              </>
            }
          />
        </Table.Body>
      </Table>

      {includeContent && (
        <Table>
          <Table.Head>Content</Table.Head>
          <Table.Body>
            <div style={{ padding: "10px", display: "flex", justifyContent: "center" }}>
              <ViewOnlyContent entry={entity} entityTypeId="notebookTemplates" />
            </div>
          </Table.Body>
        </Table>
      )}
    </>
  );
};

export const LabNotebookTemplatesDetail = ({
  permissions,
  routes,
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: EntityDetailProps<"notebookTemplates">) => {
  const { getELNTemplateRoute } = useELNRoutes();

  return (
    <div className="flex" style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <div
        className="flex col-nowrap"
        style={{ padding: "15px 15px 10px 15px", width: "100%", backgroundColor: "var(--white)" }}
      >
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          controls={
            <div className="flex align-center gap-5">
              {/* <Link to={routes.getEditLink(entity.id)}>
                <button className="btn btn-default" disabled={!permissions.canEdit(entity)}>
                  <LucideIcon name="square-pen" />
                  <span> Edit</span>
                </button>
              </Link> */}
              <EntityEditButton
                entity={entity}
                entityConstants={entityConstants}
                permissions={permissions}
                routes={routes}
              />
              <Link to={getELNTemplateRoute(entity.id)}>
                <button className="btn btn-soft-primary">
                  <LucideIcon name="eye" />
                  <span> View content</span>
                </button>
              </Link>
              <Link to={getELNTemplateRoute(entity.id, "edit")}>
                <button className="btn btn-default" disabled={!permissions.canEdit(entity)}>
                  <LucideIcon name="pencil" />
                  <span> Edit content</span>
                </button>
              </Link>
            </div>
          }
          controlsDropdown={
            <>
              <li>
                <EntityCloneButton
                  entity={entity}
                  entityConstants={entityConstants}
                  routes={routes}
                  permissions={permissions}
                />
              </li>
              <EntityComplianceDropdown entity={entity} entityTypeId={entityTypeId} />
              <li className="divider" />
              <li>
                <EntityDeleteButton entityTypeId={entityTypeId} entity={entity} />
              </li>
            </>
          }
        />

        <LabNotebookTemplatesDetailTable
          entity={entity}
          entityConstants={entityConstants}
          fieldLabels={fieldLabels}
          entityTypeId={entityTypeId}
        />
      </div>
    </div>
  );
};
